export const getPathFromUrl = (urlString) => {
  const url = new URL(urlString);
  return url.pathname;
};

export const removeTrailingSlash = (src: string) => {
  if (src.endsWith("/")) {
    return src.slice(0, src.length - 1);
  }
  return src;
};

export const appendTrailingSlash = (src: string) => {
  if (src.endsWith("/")) {
    return src;
  }
  return `${src}/`;
};

export const stripWwwPrefix = (domain?: string) =>
  (domain || "").replace(/www\./i, "");

export const isWwwDomain = (domainName?: string) => {
  if (!domainName) {
    return false;
  }

  const parts = domainName.toLowerCase().split(".");
  if (parts.length < 3) {
    return false;
  }

  const rootDomain = parts.slice(-2).join(".");
  return parts.join(".") === `www.${rootDomain}`;
};
